// import { getReports } from "api/aiChat";

const reportConfig = {
  getReports: () => null
};

export default reportConfig;